import {faCodeBranch} from "@fortawesome/free-solid-svg-icons";

export default faCodeBranch;
